import { fetchTemporaryPassword, logInUser } from '@tkmp/rfq/redux/utils';
import { Logger } from '@utils/logger/logger';
import { getMember } from '@xo-union/store-membership-redux';

export const autoLogIn =
	(email: string): Redux.ThunkResult<Promise<void>> =>
	async (
		dispatch,
		_getState,
		membershipService?: MembershipService.Service,
	) => {
		const tempPassword = fetchTemporaryPassword();
		if (!tempPassword || !membershipService) return;
		try {
			await logInUser({
				logInDetails: { email, password: tempPassword },
				membershipService,
			});
			await dispatch(getMember());
		} catch (error) {
			Logger.error({
				log_message: 'Auto login failed',
				errorToLog: error,
				newRelic: true,
			});
		}
	};
